// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3F34x","amount":"Amount_amount__VbW0u","tip":"Amount_tip__dZsN3","tipHeader":"Amount_tipHeader__2rdS7","tipsWrap":"Amount_tipsWrap__1MN5q"};